"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommentThreadSource = exports.isCommentThreadInURL = exports.getCommentThreadURL = void 0;
var querystringify_1 = __importDefault(require("querystringify"));
var CommentTypes_1 = require("@CommonFrontendBackend/Comments/Types/CommentTypes");
function getCommentThreadURL(clientUrl, projectId, threadId, source) {
    projectId = encodeURIComponent(projectId);
    var parameters = {
        "comment-thread": threadId,
        "comment-source": source,
    };
    return "".concat(clientUrl, "/#/project/").concat(projectId, "?").concat(querystringify_1.default.stringify(parameters));
}
exports.getCommentThreadURL = getCommentThreadURL;
function isCommentThreadInURL(urlString, threadId) {
    var encodedThreadId = encodeURIComponent(threadId);
    var parameters = querystringify_1.default.parse(urlString.split("?")[1] || "");
    return !!parameters["comment-thread"] && encodedThreadId === parameters["comment-thread"];
}
exports.isCommentThreadInURL = isCommentThreadInURL;
var getCommentThreadSource = function (urlString) {
    var parameters = querystringify_1.default.parse(urlString.split("?")[1] || "");
    var validValues = Object.values(CommentTypes_1.CommentThreadOpenedOrigin);
    if (validValues.includes(parameters["comment-source"])) {
        return parameters["comment-source"];
    }
    else {
        return null;
    }
};
exports.getCommentThreadSource = getCommentThreadSource;
